<template>
  <base-draggable-modal
      name="base_export"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="base_export">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate('export_to_excel') }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-row>
              <v-col cols="8">{{ $store.getters.translate("export_filtered_data") }}</v-col>
              <v-col>
                <download-excel style="font-size: 12px; text-transform: uppercase; cursor: pointer;" :fields="show_in_search_fields" :data="data" :name="page.name + '.xls'">
                  {{ $store.getters.translate("export_to_excel") }}
                  <v-icon color="primary" size="large" class="ml-2 mr-2" icon="mdi-file-excel"/>
                </download-excel>
              </v-col>
            </v-row>
            <v-row class="mt-5">
              <v-col cols="8">{{ $store.getters.translate("export_all_data") }}</v-col>
              <v-col>
                <download-excel style="font-size: 12px; text-transform: uppercase; cursor: pointer;" :fields="all_fields" :fetch="getRecordsForExport" :name="page.name + '.xls'">
                  {{ $store.getters.translate("export_to_excel") }}
                  <v-icon color="primary" size="large" class="ml-2 mr-2" icon="mdi-file-excel"/>
                </download-excel>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col class="text-center">
                <base-action-button :width="'50%'" @action="closeModal('base_export')">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhX} from "@phosphor-icons/vue";

export default {
  props: ["page", "data"],
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhX,
  },
  data() {
    return {
      show_in_search_fields: {},
      all_fields: {}
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.openModal('base_export');
      await this.getAllFields();
      await this.getShowInSearchFields();
    },
    async getRecordsForExport() {
      let records = await helpFunctions.getCustomRoute(this.$toast, this.page.name + "?source=export");
      records.data.forEach((item) => {
        if(item.equipment_type_name) {
          item.equipment_type_name = this.$store.getters.translate(item.equipment_type_name);
        }
        else if(item.distribution_device_function_name) {
          item.distribution_device_function_name = this.$store.getters.translate(item.distribution_device_function_name);
        }
      });
      return records.data;
    },
    async getAllFields() {
      this.all_fields = [];
      let fields = await helpFunctions.getCustomRoute(this.$toast, "fields?model_type=" + this.page.model, true);
      fields.forEach((item) => {
        item.name = helpFunctions.replaceIDwithNameBaseTableInc(item.name);
        this.all_fields[this.$store.getters.translate(item.name)] = item.name;
      });
    },
    async getShowInSearchFields() {
      this.show_in_search_fields = [];
      let fields = await helpFunctions.getCustomRoute(this.$toast, "fields?show_in_search=true&model_type=" + this.page.model, true);
      fields.forEach((item) => {
        item.name = helpFunctions.replaceIDwithNameBaseTableInc(item.name);
        this.show_in_search_fields[this.$store.getters.translate(item.name)] = item.name;
      });
    },
  }
};
</script>